/** Deterministic hash so the same song always gets the same fallback color. */
function hashString(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

export interface FallbackArt {
  background: string
  foreground: string
  glyph: string
}

/** Picks a pastel HSL pair and a first-letter glyph, stable per song id. */
export function getFallbackArt(id: number, title: string): FallbackArt {
  const hue = hashString(`${id}`) % 360
  const background = `hsl(${hue} 65% 88%)`
  const foreground = `hsl(${hue} 45% 32%)`
  const firstMeaningfulChar = [...title].find((char) =>
    /[\p{L}\p{N}]/u.test(char)
  )
  const glyph = (firstMeaningfulChar ?? title.trim()[0] ?? "?").toUpperCase()

  return { background, foreground, glyph }
}
